import React from 'react';

class RowItemKetQuaThanhTraChuyenNganh extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.soCuocTTKTTongSo}</td>
        <td className='txt-center'>{data.thanhLapDoan}</td>
        <td className='txt-center'>{data.thanhTraDocLap}</td>
        <td className='txt-center'>{data.caNhanDuocThanhTra}</td>
        <td className='txt-center'>{data.caNhanDuocKiemTra}</td>
        <td className='txt-center'>{data.toChucDuocThanhTra}</td>
        <td className='txt-center'>{data.toChucDuocKiemTra}</td>
        <td className='txt-center'>{data.soCoViPhamTongSo}</td>
        <td className='txt-center'>{data.soCoViPhamCaNhan}</td>
        <td className='txt-center'>{data.soCoViPhanToChuc}</td>
        <td className='txt-center'>{data.soQDXuPhatHanhChinhTongSo}</td>
        <td className='txt-center'>{data.soQDXuPhatHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.soQDXuPhatHanhChinhToChuc}</td>
        <td className='txt-center'>{data.soTienViPhamTongSo}</td>
        <td className='txt-center'>{data.soTienViPhamCaNhan}</td>
        <td className='txt-center'>{data.soTienViPhamToChuc}</td>
        <td className='txt-center'>{data.soTienKienNghiThuHoi}</td>
        <td className='txt-center'>{data.soTienXuLyTaiSanTongSo}</td>
        <td className='txt-center'>{data.soTienXuLyTaiSanTichThu}</td>
        <td className='txt-center'>{data.soTienXuLyTaiSanTieuHuy}</td>
        <td className='txt-center'>{data.soTienXuLyViPhamTongSo}</td>
        <td className='txt-center'>{data.soTienXuLyViPhamCaNhan}</td>
        <td className='txt-center'>{data.soTienXuLyViPhamToChuc}</td>
        <td className='txt-center'>{data.soTienDaThuTongSo}</td>
        <td className='txt-center'>{data.soTienDaThuCaNhan}</td>
        <td className='txt-center'>{data.soTienDaThuToChuc}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaThanhTraChuyenNganh;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaThanhTraChuyenNganh.jsx